import { SoundName } from '@constants/sounds'
import { create } from 'zustand'

interface SoundState {
    engineManager: SoundManager | null
    isEngineManagerReady: boolean
    init: () => SoundManager | null
    playEngineSound: (name: SoundName) => void
}

// If we want to play a sound without using the Engine, use the implementation from react ui which uses howler
export const useSoundStore = create<SoundState>((set, get) => ({
    engineManager: null,
    isEngineManagerReady: false,
    init: () => {
        const { engineManager: manager } = get()

        if (manager) {
            return manager
        }

        const engineManager = window.bottle?.container?.SoundManager

        if (engineManager) {
            set({ engineManager, isEngineManagerReady: true })

            return engineManager
        } else {
            console.warn('Engine Sound Manager is not initialized yet.')

            return null
        }
    },
    playEngineSound: (name: SoundName) => {
        const state = get()
        // If manager was not initialized, try it one more time before playing a sound
        const activeManager = state.engineManager || state.init()

        if (activeManager) {
            activeManager.play(name)
        }
    },
}))
